module.exports = __webpack_public_path__ + "site/img/whatszh.3a4d9dd4.png";